import { axios } from 'services/axios'
import { routes } from 'services/routes'

import {
  OnboardingTipParameters,
  OnboardingTipResponse,
  OnboardingTipsResponse,
} from './types'

export const fetchOnboardingTips = async () => {
  const response = await axios.get<OnboardingTipsResponse>(
    routes.onboardingTipsPath(),
  )
  if (!response) {
    throw new Error('Couldn\'t fetch onboarding tips')
  }
  return response.data
}

export const createOnboardingTips = async ({
  slug,
  dismissed,
}: OnboardingTipParameters) => {
  const response = await axios.post<OnboardingTipResponse>(
    routes.onboardingTipsPath(),
    {
      onboardingTip: {
        dismissed,
        slug,
      },
    },
  )
  if (!response) {
    throw new Error('Couldn\'t create onboarding tip')
  }
  return response.data
}

export const destroyAllOnboardingTips = async () => {
  const response = await axios.delete(
    routes.onboardingTipsDestroyAllPath(),
  )
  if (!response) {
    throw new Error('Couldn\'t destroy onboarding tips')
  }
  return response.data
}
